import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const StaffActivityPage = lazy(() => import('./pages/StaffActivityPage'));

export const StaffActivityRoutes: RouteObject = {
  path: 'staff-activity',
  children: [
    { path: '', element: <StaffActivityPage />, handle: { crumb: 'Staff Activity' } },
  ],
};
